import { Linkedin , Instagram , Twitter , Github } from 'react-bootstrap-icons';
import Contact from './contact';

// Page Footer 
const Footer = () => {
    return (
        <div name='contact' className='p-3 text-2xl text-center bg-indigo-900 text-white'>
            <div>
                Find me
            </div>
            <Contact />
            <div className='m-2 p-2 flex text-2xl justify-center space-x-10'>
                <a href='https://www.linkedin.com/in/maniprasad-kadlaskar-81368b1b5/'><Linkedin /></a>
                <a href='https://www.linkedin.com/in/maniprasad-kadlaskar-81368b1b5/'><Instagram /></a>
                <a href='https://www.linkedin.com/in/maniprasad-kadlaskar-81368b1b5/'><Twitter /></a>
                <a href='https://github.com/maniprasadkadlaskar'><Github /></a>
            </div>
            <div className='m-2 p-2 text-sm'>
                <span>Made with &#x2665; by Maniprasad kadlaskar</span>
            </div>
        </div>
    );
}

export default Footer;